import { Colors } from "./types";

export const baseColors = {
  failure: "#940B11",
  primary: "#7C36CA",
  primaryBright: "#73c7ff",
  primaryDark: "#0F88D9",
  secondary: "#F78749",
  success: "#39B432",
  warning: "#FFF700",
  normal: "#F9DD48",
  purple: "#7C36CA",
  white: "#FFFFFF",
  nftGrey: "#1a1a1a",
  wathet: "#3ab0ff",
  yellow: "#F5E128",
  grey: "#666666",
  greyLine: "#282C39",
  psgBlue: "#4472c4",
  bottomGrey: "#3B3659",
  blue: "#5662f6",
};

export const additionalColors = {
  binance: "#F0B90B",
  overlay: "#452a7a",
  gold: "#FFC700",
  silver: "#B2B2B2",
  bronze: "#E7974D",
};

export const lightColors: Colors = {
  ...baseColors,
  ...additionalColors,
  background: "#FAF9FA",
  backgroundDisabled: "#E9EAEB",
  backgroundAlt: "#FFFFFF",
  backgroundAlt2: "rgba(255, 255, 255, 0.7)",
  cardBorder: "#E7E3EB",
  contrast: "#191326",
  dropdown: "#F6F6F6",
  dropdownDeep: "#EEEEEE",
  invertedContrast: "#FFFFFF",
  input: "#EEEAF4",
  inputSecondary: "#B8B533",
  tertiary: "#EFF4F5",
  text: "#0D354F",
  textDisabled: "#BDC2C4",
  textSubtle: "#7A6EAA",
  disabled: "#E9EAEB",
  gradients: {
    bubblegum: "linear-gradient(139.73deg, #79D2A1, #79D2C7, #B8D279, #CED279)",
    inverseBubblegum: "linear-gradient(139.73deg, #CED279, #B8D279, #79D2C7, #79D2A1)",
    cardHeader: "linear-gradient(139.73deg, #79D2A1, #79D2C7, #B8D279, #CED279)",
    blue: "linear-gradient(180deg, #A7E8F1 0%, #94E1F2 100%)",
    violet: "linear-gradient(180deg, #E2C9FB 0%, #CDB8FA 100%)",
    violetAlt: "linear-gradient(180deg, #CBD7EF 0%, #9A9FD0 100%)",
    gold: "linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)",
  },
};

export const darkColors: Colors = {
  ...baseColors,
  ...additionalColors,
  secondary: "#F78749",
  background: "#070908",
  backgroundDisabled: "#3c3742",
  backgroundAlt: "#27262c",
  backgroundAlt2: "rgba(0, 0, 0, 0.7)",
  cardBorder: "#282C39",
  contrast: "#FFFFFF",
  dropdown: "#1E1D20",
  dropdownDeep: "#100C18",
  invertedContrast: "#191326",
  input: "#372F47",
  inputSecondary: "#262130",
  primaryDark: "#0098A1",
  tertiary: "#4B427D",
  text: "#F4EEFF",
  textDisabled: "#666171",
  textSubtle: "#B8ADD2",
  disabled: "#524B63",
  gradients: {
    bubblegum: "linear-gradient(139.73deg, #40BFB8, #462D86, #34194D, #4D1919)",
    inverseBubblegum: "linear-gradient(139.73deg, #4D1919, #34194D, #462D86, #40BFB8)",
    cardHeader: "linear-gradient(139.73deg, #40BFB8, #462D86, #34194D, #4D1919)",
    blue: "linear-gradient(180deg, #00707F 0%, #19778C 100%)",
    violet: "linear-gradient(180deg, #6C4999 0%, #6D4DB2 100%)",
    violetAlt: "linear-gradient(180deg, #434575 0%, #66578D 100%)",
    gold: "linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)",
  },
};
